import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PerformersEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import lang from 'dojo/_base/lang';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { EntityExistCheck } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import Button from '../../../moreCore/UI/Button/Button';
import AddressView from '../../AddressFinder/AddressView';
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';


class PerformersEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private originalMainProfessionState: boolean = false;

    private addressHintboxSection: HTMLDivElement;
    private addressHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private ea_addressHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private pseudonymEdit: MdsLax<InstanceType<typeof Edit>>;
    private professionHintbox: MdsLax<InstanceType<typeof HintBox>>;
    //private na_professionHintbox: HintBox;
    //private no_professionHintbox: HintBox;
    private pagestack: MdsLax<InstanceType<typeof PageStack>>;
    private mainProfessionCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    //private na_mainProfessionCheckbox: CheckBox;
    //private no_mainProfessionCheckbox: CheckBox;
    private activeCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    //private na_activeCheckbox: CheckBox;
    //private no_activeCheckbox: CheckBox;
    private salutationSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    private firstnameEdit: MdsLax<InstanceType<typeof Edit>>;
    private lastnameEdit: MdsLax<InstanceType<typeof Edit>>;
    private no_nameEdit: MdsLax<InstanceType<typeof Edit>>;


    //private professionExpander: ExpandableSection;
    private professionSection: HTMLDivElement;
    private professionTable: MdsLax<InstanceType<typeof StaticTable>>;
    private performerStore: MdsLax<InstanceType<typeof EntityStore<VAM2types.Performer>>>;

    private personEntityExistCheck: MdsLax<InstanceType<typeof EntityExistCheck>>;
    private organizationEntityExistCheck: MdsLax<InstanceType<typeof EntityExistCheck>>;

    private flagSwitch_firstLoad = true;


    private rowConfig: StaticTable.RowConfig = {
        attributes: ["ref_ev_profession.description", "is_active", "is_main_profession"],
        headings: [(this as any).translate("General_Label_Profession"), (this as any).translate("General_Label_IsActive"), (this as any).translate("General_Label_IsMainProfession")],
    }

    private tableLayout: StaticTable.Layout = {
        label: "professionTable",
        name: "professionTable",
        rows: [(this as any).rowConfig]
    }

    isValid(): boolean {
        let page = this.pagestack.getActivePageName();

        switch (page) {
            case "existingAddress":
                if (!this.getAttributeValue("ref_address")) return false;
                if (!this.professionHintbox.getValue()) return false;
                if (this._storeHasProfession(this.getAttributeValue("ref_ev_profession")) && this.isNew) {
                    this.showToast(this.translate("PerformersEditor_Error_StoreHasProfession"), "fas fa-exclamation-triangle");
                    return false;
                }
                break;
            case "newAddress":
                //if (!this.na_professionHintbox.getValue()) return false;
                console.log(
                    this.getAttributeValue("salutation"),
                    this.getAttributeValue("firstname"),
                    this.getAttributeValue("lastname")
                )
                if (!this.getAttributeValue("salutation")) return false;
                if (!this.getAttributeValue("firstname")) return false;
                if (!this.getAttributeValue("lastname")) return false;
                if (!this.personEntityExistCheck.isValid()) return false;
                break;
            case "newOrganisation":
                if (!this.getAttributeValue("name")) return false;
                //if (!this.no_professionHintbox.getValue()) return false;
                if (!this.organizationEntityExistCheck.isValid()) return false;
                break;
        }
        if (!this.getAttributeValue("ref_ev_profession")) return false;

        return true;
    }



    private setupTable() {
        this.professionTable = new StaticTable();
        this.professionTable.setLayout(this.tableLayout);
        this.professionTable.setupFromStore(this.performerStore);
        this.professionTable.setCyAttribute("PerformersEditorProfessionTable");
        this.professionTable.placeAt(this.professionSection);
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);
        console.log(this.getAttributeValue("ref_address").pseudonym);
        this.setAttributeValue("pseudonym", this.getAttributeValue("ref_address").pseudonym);

        if (!this.isNew) {
            this.performerStore.setup(this.getAttributeValue("ref_address.EL_performers_address"));
            this.pseudonymEdit.setReadonly(true);
            this.addressHintbox.setReadonly(true);
            this.professionHintbox.setReadonly(true);
            this.pagestack.disablePage("newAddress");
            this.pagestack.disablePage("newOrganisation");
            this.hideNode(this.pagestack, true);
            this.hideNode(this.addressHintboxSection, false)
        }
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.Performers;
    }

    private _storeHasProfession(profession: VAM2types.EvProfession) {
        let completeList = this.performerStore.getCurrentCompleteList();

        if (!profession) return false;

        for (let performer of completeList) {
            if (performer.ref_ev_profession.ID === profession.ID) return true;
        }

        return false;
    }

    private _onChangeAddress(e) {
        let address = this.addressHintbox.getValue("entity");
        if (address !== undefined) {
            this.performerStore.setup(address ? address.EL_performers_address : []);

            this.setAttributeValue("ref_address", address);
            this.setAttributeValue("pseudonym", address ? address.pseudonym : "");
        }
    }

    private _onClickSEDButton(type: string, e: MouseEvent) {
        this.loadSelectEntityDialog(e, type, lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<more.EntityAPIResultExtended>>) {
        if (items && items.length > 0) {
            let result = items[0].entry.data
            switch (mode) {
                case "selectAddress":
                    this.addressHintbox.setValue(result);
                    break;
                case "selectProfession":
                    this.professionHintbox.setValue(result);
                    break;
            }
        }


    }

    protected beforeSave() {
        let page = this.pagestack.getActivePageName();

        switch (page) {
            case "newAddress":
                this.setAttributeValue("is_new_address", true);
                this.setAttributeValue("address_class", "persons");
                break;
            case "newOrganisation":
                this.setAttributeValue("is_new_address", true);
                this.setAttributeValue("address_class", "organisations_external");
                break;
            case "existingAddress":
                this.setAttributeValue("is_new_address", false);
                break;
        }
    }

    private _onEditChange(type: string, e: string) {
        this.setAttributeValue(type, e);

        switch (type) {
            case "firstname":
            case "lastname":

                let lastname = this.getAttributeValue("lastname");
                if (lastname) {
                    let firstname = this.getAttributeValue("firstname");
                    let attributes = {
                        lastname: lastname,
                        firstname: firstname
                    }
                    this.personEntityExistCheck.requestCheck("performer_person", attributes);
                }
                break;
            case "name":
                let name = this.getAttributeValue("name");
                let attributes = {
                    name: name
                }
                this.organizationEntityExistCheck.requestCheck("performer_organization", attributes);
                break;
        }
    }

    private _onSalutationChange() {
        let salutation = this.salutationSelect.getValue(true);
        this.setAttributeValue("salutation", salutation);
        if (this.flagSwitch_firstLoad != false){
            //aus irgend ein grund setzt setAttributeValue value immer auf dirty beim first load
            this.flagSwitch_firstLoad = false;
            this.forceSetDirty(false);
        }
    }


    private _onPageChange(pageName: string): void {
        if (this.isNew) {
            switch (pageName) {
                case "newAddress":
                default:
                    this.pseudonymEdit.setReadonly(false);
                    this.setAttributeValue("pseudonym", "");
                    this.performerStore.setup([]);
                    this.hideNode(this.professionSection, true);
                    break;
                case "existingAddress":
                    this.pseudonymEdit.setReadonly(true);
                    let address = this.getAttributeValue("ref_address");
                    this.setAttributeValue("pseudonym", address ? address.pseudonym : "");
                    this.performerStore.setup(address ? address.EL_performers_address : this.getAttributeValue("ref_address.EL_performers_address"));
                    this.hideNode(this.professionSection, false);
                    break;
            }
        }
    }

    private _entityExistCallback(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>) {

        this.addressHintbox.setValue(rowGroup.entity);
        this.pagestack.activatePageByName("existingAddress");
    }

    private createAdressEntityViewButton() {

        if (!this.hasUserRole("Addresses_Read")) return;

        let btn = new Button();

        btn.setup({
            parentNode: this.addressHintboxSection,
            //disabledClasses: "moreCoreButton buttonBase secondaryBG",
            //enabledClasses: "mds-button-base primaryBG padding",
            styleClass: "mds-button-base primaryBG padding hoverBright",
            iconClass: "fas fa-address-card",
            callback: () => {
                let view = new AddressView();
                let address = this.getAttributeValue("ref_address");
                if (!address) return;
                view.showAsDlg(address.ID, address.gDisp_1, this.getTabContainerName());

                view.on("change", lang.hitch(this, this.loadEntity, this.entityId));
                view.on("deleted", lang.hitch(this, this.close));
            }
        })
        this.UiModder.domClass.remove(btn.domNode, "buttonBase");

        let tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("AddressView_Tooltip_ShowAddressView"),
            targetnode: btn.domNode,
            delayMS: 200
        })
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addressHintbox.addInlineButton(lang.hitch(this, this._onClickSEDButton, "selectAddress"));
        this.professionHintbox.addInlineButton(lang.hitch(this, this._onClickSEDButton, "selectProfession"));

        this.firstnameEdit.on("change", lang.hitch(this, this._onEditChange, "firstname"));
        this.lastnameEdit.on("change", lang.hitch(this, this._onEditChange, "lastname"));
        this.no_nameEdit.on("change", lang.hitch(this, this._onEditChange, "name"));

        this.salutationSelect.on("change", lang.hitch(this, this._onSalutationChange));

        this.setAttributeValue("salutation", null);
        this.setAttributeValue("name", "");
        this.setAttributeValue("firstname", "");
        this.setAttributeValue("lastname", "");
        this.setAttributeValue("pseudonym", "");


        this.performerStore = new EntityStore();
        this.setupTable();

        this.setAttributeValue("is_active", true);

        this.pagestack.activatePageByName("existingAddress");

        this.pagestack.on("pageChange", lang.hitch(this, this._onPageChange));

        this.SEDconfigCallfunction = "Webtool_API_Performers__SED_GetConfig";

        this.personEntityExistCheck.setup({
            operationMode: "open",
            entityListRowClickEnabled: true,
            entityListTableRowClickCallback: lang.hitch(this, this._entityExistCallback)
        })
        this.organizationEntityExistCheck.setup({
            operationMode: "open",
            entityListRowClickEnabled: true,
            entityListTableRowClickCallback: lang.hitch(this, this._entityExistCallback)
        })

        this.createAdressEntityViewButton();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(PerformersEditor);
